import { startOfMonth, endOfMonth, subMonths, subDays, startOfYear, format } from 'date-fns';

export const getPresetRange = (preset, today = new Date()) => {
  const t = new Date(today);
  t.setHours(0, 0, 0, 0);
  switch (preset) {
    case 'last30Days':
      return { start: subDays(t, 30), end: t };
    case 'thisMonth':
      return { start: startOfMonth(t), end: t };
    case 'lastMonth': {
      const prev = subMonths(t, 1);
      return { start: startOfMonth(prev), end: endOfMonth(prev) };
    }
    case 'last3Months':
      return { start: subMonths(t, 3), end: t };
    case 'last6Months':
      return { start: subMonths(t, 6), end: t };
    case 'ytd':
      return { start: startOfYear(t), end: t };
    default:
      return { start: subDays(t, 30), end: t };
  }
};

export const toIsoDate = (date) => format(date, 'yyyy-MM-dd');

// Drill-down bağlamı: URL'de baslangic+bitis varsa onları kullan (cockpit'ten
// taşınan dönem), yoksa sayfanın varsayılan preset'i. Böylece bir KPI/grafiğe
// tıklayıp gelen analiz sayfası, cockpit'te seçili dönemle açılır.
export const rangeFromUrl = (searchParams, fallbackPreset = 'last30Days') => {
  const b = searchParams && searchParams.get('baslangic');
  const e = searchParams && searchParams.get('bitis');
  if (b && e) return { preset: 'custom', start: b, end: e };
  const r = getPresetRange(fallbackPreset);
  return { preset: fallbackPreset, start: toIsoDate(r.start), end: toIsoDate(r.end) };
};

export const formatRangeLabel = (start, end) =>
  `${format(start, 'd MMM yyyy')} – ${format(end, 'd MMM yyyy')}`;
